import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { HttpErrorResponse } from '@angular/common/http';
import { HotToastService } from '@ngneat/hot-toast';

import { CountryDto, RegionDto, UserAddressDto } from 'src/app/core/dtos/dto';
import { CountryRegionService } from '../../../core/services/country-region.service';
import { AddressFormData } from 'src/app/core/dtos/address-form-data';

@Component({
  selector: 'app-address-form',
  templateUrl: './address-form.component.html',
  styleUrls: ['./address-form.component.scss']
})
export class AddressFormComponent implements OnInit {

  @Input() submitted: boolean;
  @Input() address: UserAddressDto;
  @Input() heading: string;
  @Input() countries: CountryDto[];
  @Input() isFullNameDisabled: boolean;
  @Input() isOrderSummaryAddress: boolean;

  @Output() formValueChanged = new EventEmitter<AddressFormData>();

  formGroup: FormGroup;
  regions: RegionDto[] = [];

  get f() { return this.formGroup.controls; }

  constructor(
    private formBuilder: FormBuilder,
    private toastService: HotToastService,
    private countryService: CountryRegionService,
  ) {
  }

  ngOnInit(): void {
    this.createForm();
    if (this.address.countryId) {
      this.getRegions(this.address.countryId);
    }
  }

  createForm() {
    if (!this.formGroup) {
      this.formGroup = this.formBuilder.group({
        addressLine1: ['', [Validators.required, Validators.maxLength(60)]],
        addressLine2: ['', Validators.maxLength(60)],
        buzzerNumber: [''],
        city: ['', [Validators.required, Validators.maxLength(50)]],
        countryId: ['', Validators.required],
        fullName: [{ value: '', disabled: this.isFullNameDisabled }, [Validators.required, Validators.maxLength(50)]],
        phoneNumber: ['', [Validators.required, Validators.pattern("^[0-9]*$"), Validators.minLength(5)]],
        postalCode: ['', Validators.required],
        regionAbbrOrName: ['', [Validators.required, Validators.maxLength(20)]],
        suite: [''],
        poBoxNumber: [''],
      });

      this.formGroup.patchValue(this.address);
      this.formGroup.get("countryId").valueChanges.subscribe(countryId => {
        this.formGroup.get("regionAbbrOrName").setValue(null);
        this.getRegions(countryId);
      });
      this.formGroup.valueChanges.subscribe(address => {
        const addressInputFormat = this.countries.find(x => x.id === address.countryId)?.addressInputFormat;
        this.formValueChanged.emit({ isValid: this.formGroup.valid, address: { ...address, addressInputFormat } });
      });
    }
  }

  updateRegionControl() {
    const regionAbbrOrNameControl = this.formGroup.get("regionAbbrOrName");
    regionAbbrOrNameControl.updateValueAndValidity();
  }

  getRegions(countryId: number) {
    this.countryService.getRegions(countryId)
      .subscribe(
        result => {
          this.regions = result.content;
          this.updateRegionControl();
        },
        (error: HttpErrorResponse) => {
          if (error.status !== 401) {
            this.toastService.warning("Unable to load regions.");
          }
        });
  }

}

